import React from 'react';

import { formatNumber } from '../../../core/helpers/format-number';
import { TableCol6Model } from '../../../core/models/tables';

interface IUkPlannedTable {
  data: TableCol6Model[];
}

export default function UkPlannedTable({ data }: IUkPlannedTable): JSX.Element {
  return (
    <div className="UkPlannedTable">
      <h3>UK Facilities Availability (mcm/d)</h3>
      <div className="table-container">
        <table className="total-table total-table-stripped table-sm">
          <thead>
            <tr>
              <th>Gas Field</th>
              <th>Category</th>
              <th>Capacity</th>
              <th>Impact Value (*)</th>
              <th>Actual Capacity</th>
              <th>Start Date</th>
              <th>Duration (days)</th>
            </tr>
          </thead>
          <tbody>
            {data.map((ukPlanned, index) => (
              <tr key={index}>
                <td>{ukPlanned.col1}</td>
                <td>{ukPlanned.col2}</td>
                <td>{formatNumber(ukPlanned.col3)}</td>
                <td>{formatNumber(ukPlanned.col4)}</td>
                <td>{formatNumber(ukPlanned.col5)}</td>
                <td>{ukPlanned.col6}</td>
                <td>{ukPlanned.col7}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="note">* Only outages of 10 mcm/d or higher are shown</p>
      </div>
    </div>
  );
}
